export const InboxEvent = {
  ON_SEND_MESSAGE: 'InboxEvent:ON_SEND_MESSAGE',
  ON_UNREAD_CHANGED: 'InboxEvent:ON_UNREAD_CHANGED',
  ON_CONVERSATION_SELECTED: 'InboxEvent:ON_CONVERSATION_SELECTED',
  ON_INBOX_MOUNTED: 'InboxEvent:ON_INBOX_MOUNTED',
  NEED_REFRESH_INBOX: 'InboxEvent:NEED_REFRESH_INBOX',
  SHOW_LOADER: 'InboxEvent:SHOW_LOADER',
  ON_NEW_CONVERSATION_CREATED: 'InboxEvent:ON_NEW_CONVERSATION_CREATED',
  ON_NEW_CONVERSATION: 'InboxEvent:ON_NEW_CONVERSATION',
  ON_UPDATE_CONVERSATION: 'InboxEvent:ON_UPDATE_CONVERSATION',
  INBOX_IMPERSONATING: 'InboxEvent:INBOX_IMPERSONATING',
  GO_TO_CONVERSATION: 'InboxEvent:GO_TO_CONVERSATION',
  OPEN_AI_RESEARCH: 'InboxEvent:OPEN_AI_RESEARCH'
};
